import { render, staticRenderFns } from "./trainingModulePageNew8.vue?vue&type=template&id=4ea3d748&scoped=true&"
import script from "./trainingModulePageNew8.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageNew8.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageNew8.vue?vue&type=style&index=0&id=4ea3d748&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea3d748",
  null
  
)

export default component.exports